export default function AboutContact() {
  return (
    <>
      <section id="about" className="py-14 md:py-20 bg-background-100">
        <div className="max-w-[1440px] mx-auto px-4 md:px-6">
          <div className="max-w-3xl mx-auto text-center">
            <h2 className="font-heading text-2xl md:text-3xl text-foreground-950 mb-4">关于日韩影视网</h2>
            <p className="text-sm md:text-base text-foreground-600 leading-relaxed mb-6">
              日韩影视网成立于2020年，是专注于日本电影免费在线观看与韩国电影免费高清资源的专业影视平台。我们致力于为华语观众提供最新、最全、最高清的日韩电影在线观看体验。平台收录超过10000部日本电影与韩国电影，覆盖动作、爱情、悬疑、恐怖、动画、历史、科幻、纪录片等多种题材类型。
            </p>
            <p className="text-sm md:text-base text-foreground-600 leading-relaxed mb-8">
              日韩影视网坚持每日更新片库，第一时间同步日韩最新影视资源。所有影片支持高清画质急速播放，无需注册即可免费在线观看。无论是韩国电影免费大片还是日本电影免费经典，日韩影视网都是影迷追剧看片的理想选择。
            </p>
            <div className="grid grid-cols-2 sm:grid-cols-4 gap-4">
              {[
                { num: '5年+', label: '稳定运营' },
                { num: '10000+', label: '影片收录' },
                { num: '50万+', label: '日活用户' },
                { num: '每日', label: '持续更新' },
              ].map((stat) => (
                <div key={stat.label} className="p-4 rounded-xl bg-background-50 border border-background-200/70">
                  <div className="font-heading text-xl md:text-2xl text-primary-600">{stat.num}</div>
                  <div className="text-xs text-foreground-500 mt-1">{stat.label}</div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>

      <section id="contact" className="py-14 md:py-20 bg-background-50">
        <div className="max-w-[1440px] mx-auto px-4 md:px-6">
          <div className="max-w-2xl mx-auto text-center">
            <h2 className="font-heading text-2xl md:text-3xl text-foreground-950 mb-2">联系我们</h2>
            <p className="text-sm text-foreground-500 mb-8">有影片推荐、版权问题或合作意向？欢迎通过以下方式联系我们</p>
            <div className="grid grid-cols-1 sm:grid-cols-3 gap-4">
              <div className="p-5 rounded-xl bg-background-100 border border-background-200/70 hover:border-accent-200 transition-colors">
                <div className="w-11 h-11 flex items-center justify-center rounded-xl bg-accent-100 mx-auto mb-3">
                  <i className="ri-mail-line text-accent-600 text-xl"></i>
                </div>
                <h3 className="font-heading text-sm text-foreground-900 mb-1">意见反馈</h3>
                <p className="text-xs text-foreground-500">feedback@rihanys.com</p>
              </div>
              <div className="p-5 rounded-xl bg-background-100 border border-background-200/70 hover:border-accent-200 transition-colors">
                <div className="w-11 h-11 flex items-center justify-center rounded-xl bg-accent-100 mx-auto mb-3">
                  <i className="ri-movie-line text-accent-600 text-xl"></i>
                </div>
                <h3 className="font-heading text-sm text-foreground-900 mb-1">影片推荐</h3>
                <p className="text-xs text-foreground-500">recommend@rihanys.com</p>
              </div>
              <div className="p-5 rounded-xl bg-background-100 border border-background-200/70 hover:border-accent-200 transition-colors">
                <div className="w-11 h-11 flex items-center justify-center rounded-xl bg-accent-100 mx-auto mb-3">
                  <i className="ri-service-line text-accent-600 text-xl"></i>
                </div>
                <h3 className="font-heading text-sm text-foreground-900 mb-1">商务合作</h3>
                <p className="text-xs text-foreground-500">biz@rihanys.com</p>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}